(function(){
  var FREE_SHIPPING_THRESHOLD = 39.99;
  var updating = false;
  var observer = null;

  function updateShippingBar() {
    if (updating) return;
    updating = true;

    var textEl = document.getElementById('cart-free-shipping-text');
    var barEl = document.getElementById('cart-free-shipping-bar');
    if (!textEl || !barEl) { updating = false; return; }

    var priceEl = document.querySelector('.xk-totals p');
    if (!priceEl) { updating = false; return; }

    var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
    var cartTotal = parseFloat(priceText) || 0;

    var tipsText = '';
    var percent = 0;

    barEl.classList.remove('cart_progress-in-full');

    if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
      tipsText = 'Your order is free delivery';
      percent = 100;
      barEl.classList.add('cart_progress-in-full');
    } else if (cartTotal > 0) {
      var diff = (FREE_SHIPPING_THRESHOLD - cartTotal).toFixed(2);
      tipsText = 'Buy $' + diff + ' more to enjoy FREE Shipping';
      percent = Math.floor((cartTotal / FREE_SHIPPING_THRESHOLD) * 100);
    } else {
      tipsText = 'Buy $' + FREE_SHIPPING_THRESHOLD.toFixed(2) + ' more to enjoy FREE Shipping';
      percent = 0;
    }

    textEl.innerHTML = tipsText;
    barEl.style.width = percent + '%';

    setTimeout(function(){ updating = false; }, 300);
  }

  function init() {
    updateShippingBar();

    var target = document.getElementById('main-cart-footer');
    if (target) {
      observer = new MutationObserver(function(){
        setTimeout(updateShippingBar, 150);
      });
      observer.observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
